import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CustomAsyncValidatorFn } from '../model/form-elements.model';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationSettings } from '@core/services/notification/notification';
import { ValidateCouponCodeResponse } from '@models/api-orders.models';

export const basketCouponValidator =
    (
        checkService: {
            checkCouponCode: (code: string) => Observable<ValidateCouponCodeResponse>;
        },
        notificationService: {
            createNotification: (settings: NotificationSettings) => void;
        }
    ): CustomAsyncValidatorFn =>
    control => {
        const code = control.value;
        if (!code) {
            return of(null);
        }
        return checkService.checkCouponCode(code).pipe(
            // KOP-2389 | we need to take a look on the error code in order to make a custom error
            catchError(err => of(err)),
            map(result => {
                if (result instanceof HttpErrorResponse) {
                    const { status } = result;
                    if (status === 429) {
                        notificationService.createNotification({
                            type: 'error',
                            translationHeadline: 'discountCode.notificationHeadline',
                            translationText: 'discountCode.notificationText'
                        });
                        return { throttled: true as const };
                    }

                    return { invalidCoupon: true as const };
                }

                if (result && result.customErrorMessage) {
                    notificationService.createNotification({
                        type: 'error',
                        translationHeadline: 'discountCode.customError.notificationHeadline',
                        translationText: result.customErrorMessage,
                        fadeTime: 0
                    });

                    return { invalidCustomCoupon: true as const, message: result.customErrorMessage };
                }

                return null;
            })
        );
    };
